import _asyncToGenerator from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import request from '../utils/request';
import { deviceInfo } from '../utils/env';
import { resultCodeCheck } from './base';
var deviceInfoData = deviceInfo();
// 获取平台映射值
var getPlatform = function getPlatform() {
  if (deviceInfoData.isAndroid) {
    return 8;
  }
  if (deviceInfoData.isIOS) {
    return 9;
  }
  return 10;
};
var baseParams = {
  platform: getPlatform()
};
export var sendCaptcha = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            params.businessType = params.businessType || 1;
            Object.assign(params, baseParams);
            return _context.abrupt("return", request.post('/rest/o/w/mobile/sendMobileCodeByBusiness', params));
          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function sendCaptcha(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var loginByPhone = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(params) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            params.businessType = params.businessType || 1;
            Object.assign(params, baseParams);
            return _context2.abrupt("return", request.post('/rest/o/w/user/login/mobileCode', params));
          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function loginByPhone(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
// 密码登录
export var loginByPass = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(params) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            params.businessType = params.businessType || 1;
            return _context3.abrupt("return", request.post('/rest/o/w/user/password/login', params));
          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function loginByPass(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
export var requestCookie = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(params) {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            Object.assign(params, baseParams);
            return _context4.abrupt("return", request.get('/rest/o/w/user/login/setCookie', {
              params: params
            }));
          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return function requestCookie(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
// 端外获取用户信息
export var getUserInfo = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", request.post('/rest/o/w/user/login/visitor/info', baseParams));
          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return function getUserInfo() {
    return _ref5.apply(this, arguments);
  };
}();
// 端内获取用户信息
export var inAppUserInfo = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(params) {
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", request.post('/rest/o/w/v0/user/profile', params));
          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return function inAppUserInfo(_x5) {
    return _ref6.apply(this, arguments);
  };
}();
// 端外支持三方登陆
export var jointLogin = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(params) {
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", request.post('/rest/o/w/user/openid/login', params));
          case 1:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return function jointLogin(_x6) {
    return _ref7.apply(this, arguments);
  };
}();
/**
 * 背景：上面两个接口并没有返回国家字段，让账号同学改排期太长，改不动，所以只有业务增加一个查询接口
 * 根据用户id获取用户所在的国家
 * 端外 /rest/o/w/wallet/recharge/thirdparty/userInfo
 * 端内 /rest/o/wallet/recharge/thirdparty/userInfo
 */
export var getUserCountryByUid = function getUserCountryByUid(config) {
  return function (params) {
    var url = config.inApp ? '/rest/o/wallet/recharge/thirdparty/userInfo' : '/rest/o/w/wallet/recharge/thirdparty/userInfo';
    return request.post(url, params).then(resultCodeCheck);
  };
};